import React, { Component } from 'react';
import { observer } from "mobx-react";
import ListButtons from "./ListButtons";
import Buttons from "./Buttons";
import Linkify from 'react-linkify';
import store from '../store/main';

class Bot extends Component {

    state = {
            loading:this.props.loading
        }

    componentDidMount(){
            setTimeout(() =>{
                this.setState({loading:false})
                store.messages.map((message)=>{
                return message.loading = false;
                })
            },2000);
    }

    render() {
        const loading = () => {

            return (
             <div className="typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
            </div>
            )
        }
        const options = () => (
            this.props.options.map((option,i)=>{
                return <ListButtons key={i} name={option}/>
                })
            );

            const buttons = () => (
                this.props.buttons.map((button,i)=>{
                    return <Buttons key={i} name={button}/>
                    })
                );
        return (
            <Linkify properties={{target: '_blank',style: {color: '#f16522  ', fontWeight: 'light'}}} >
            <p className="bot">
                {this.state.loading?<div>{loading()}<div className="icon-ms"></div></div>:<div>
                {this.props.message || '...'} <br/>
                <div className="row-buttons">
                <div>{this.props.options ? options() :'' }</div>
                <div>{this.props.buttons ? buttons() :'' }</div>
                </div>
                <div className="minutes">{this.props.time}</div>
                <div className="icon-ms"></div>
                 </div>}
            </p>
            </Linkify>
        )
    }
}

export default observer(Bot);
